import React from "react";
import {useEffect} from "react";
import {useSelector} from "react-redux";
import {css, Theme} from "@emotion/react";

import {Text} from "@pg-design/text-module";
import {isEmpty} from "@pg-mono/nodash";
import {RequestState} from "@pg-mono/request-state";

import {IRPStore} from "../../../app/rp_reducer";
import {NearbyOffersPanel} from "../../../nearby_offers/NearbyOffersPanel";
import {NearbyOffersPanelPlaceholder} from "../../../nearby_offers/NearbyOffersPanelPlaceholder";
import {getRequestStateFromRtkQuery} from "../../../store/utils/get_request_state_from_rtk_query";
import {neighborhoodOffersClickHit} from "../../../tracking/algolytics_hits/neighborhood_offers_click_hit";
import {neighborhoodOffersViewHit} from "../../../tracking/algolytics_hits/neighborhood_offers_view_hit";
import {ViewType} from "../../../view_type/ViewType";
import {useGetOfferListQuery} from "../../api/get_offer_list";
import {ISlugParsed} from "../../helpers/friendly_offer_list/offer_url_parser";
import {getListingPageNearbyOffersPayload} from "../../utils/get_listing_page_nearby_offers_payload";
import {getCountryId} from "../helpers/sub_type/get_fetch_offer_list_query";

interface IProps {
    viewType: ViewType;
    regionWhere: string;
    offerParams: Partial<ISlugParsed> | null;
}

/**
 *  `NearbyOffersMoreCard` is already styled, but we are waiting for business to define logic that should display it.
 *  After this logic is defined, check if this component can be merged with `DetailNearbyOffers`
 */
export const OfferListNearbyOffers: React.FunctionComponent<IProps> = (props) => {
    const {viewType, offerParams} = props;
    const list = useSelector((state: IRPStore) => state.offerList.list);
    const selectedRegions = useSelector((state: IRPStore) => state.offerList.selectedRegions);
    const country = useSelector((state: IRPStore) => state.offerList.list.latestQuery.country);
    const singleRegion = selectedRegions.length === 1 ? selectedRegions[0] : undefined;

    const {
        data: nearbyOffersResponse,
        isSuccess,
        isUninitialized,
        isLoading,
        isFetching,
        isError
    } = useGetOfferListQuery(getListingPageNearbyOffersPayload({offerParams, singleRegion}), {
        skip: list.requestState !== RequestState.Success
    });

    const nearbyOffers = nearbyOffersResponse ? nearbyOffersResponse.results : [];

    // Neighborhood offers hits
    useEffect(() => {
        if (!isEmpty(nearbyOffers)) {
            neighborhoodOffersViewHit(
                viewType,
                nearbyOffers.map((off: {id: number}) => off.id)
            );
        }
    }, [JSON.stringify(nearbyOffers)]);
    const onNeighborhoodBoxClick = (e: React.MouseEvent, offerId: number) => neighborhoodOffersClickHit(viewType, offerId);

    const listingHeadline = "Oferty, które mogą Cię zainteresować";

    return (
        <>
            <Text variant="headline_4" as="h3" css={headingStyle}>
                {listingHeadline}:
            </Text>

            {!isSuccess ? (
                <NearbyOffersPanelPlaceholder />
            ) : (
                <NearbyOffersPanel
                    offersNearby={nearbyOffers}
                    gtmData={{
                        listingName: listingHeadline,
                        country: getCountryId(country)
                    }}
                    onBoxClick={onNeighborhoodBoxClick}
                    modalQuery={{
                        isInitialized: !isUninitialized,
                        isSuccess,
                        isLoading: isLoading || isFetching,
                        isError,
                        requestState: getRequestStateFromRtkQuery({isSuccess, isLoading, isFetching, isError}),
                        data: nearbyOffers,
                        count: nearbyOffers.length,
                        page: nearbyOffersResponse.page,
                        pageSize: nearbyOffersResponse.page_size
                    }}
                />
            )}
        </>
    );
};

const headingStyle = (theme: Theme) => css`
    margin-bottom: 2.4rem;
    @media (min-width: ${theme.breakpoints.md}) {
        margin-bottom: 3.6rem;
    }
`;
import React from "react";
import {useEffect} from "react";
import {useSelector} from "react-redux";
import {css, Theme} from "@emotion/react";

import {Text} from "@pg-design/text-module";
import {isEmpty} from "@pg-mono/nodash";
import {RequestState} from "@pg-mono/request-state";

import {IRPStore} from "../../../app/rp_reducer";
import {NearbyOffersPanel} from "../../../nearby_offers/NearbyOffersPanel";
import {NearbyOffersPanelPlaceholder} from "../../../nearby_offers/NearbyOffersPanelPlaceholder";
import {getRequestStateFromRtkQuery} from "../../../store/utils/get_request_state_from_rtk_query";
import {neighborhoodOffersClickHit} from "../../../tracking/algolytics_hits/neighborhood_offers_click_hit";
import {neighborhoodOffersViewHit} from "../../../tracking/algolytics_hits/neighborhood_offers_view_hit";
import {ViewType} from "../../../view_type/ViewType";
import {useGetOfferListQuery} from "../../api/get_offer_list";
import {ISlugParsed} from "../../helpers/friendly_offer_list/offer_url_parser";
import {getListingPageNearbyOffersPayload} from "../../utils/get_listing_page_nearby_offers_payload";
import {getCountryId} from "../helpers/sub_type/get_fetch_offer_list_query";

interface IProps {
    viewType: ViewType;
    regionWhere: string;
    offerParams: Partial<ISlugParsed> | null;
}

/**
 *  `NearbyOffersMoreCard` is already styled, but we are waiting for business to define logic that should display it.
 *  After this logic is defined, check if this component can be merged with `DetailNearbyOffers`
 */
export const OfferListNearbyOffers: React.FunctionComponent<IProps> = (props) => {
    const {viewType, offerParams} = props;
    const list = useSelector((state: IRPStore) => state.offerList.list);
    const selectedRegions = useSelector((state: IRPStore) => state.offerList.selectedRegions);
    const country = useSelector((state: IRPStore) => state.offerList.list.latestQuery.country);
    const singleRegion = selectedRegions.length === 1 ? selectedRegions[0] : undefined;

    const {
        data: nearbyOffersResponse,
        isSuccess,
        isUninitialized,
        isLoading,
        isFetching,
        isError
    } = useGetOfferListQuery(getListingPageNearbyOffersPayload({offerParams, singleRegion}), {
        skip: list.requestState !== RequestState.Success
    });

    const nearbyOffers = nearbyOffersResponse ? nearbyOffersResponse.results : [];

    // Neighborhood offers hits
    useEffect(() => {
        if (!isEmpty(nearbyOffers)) {
            neighborhoodOffersViewHit(
                viewType,
                nearbyOffers.map((off: {id: number}) => off.id)
            );
        }
    }, [JSON.stringify(nearbyOffers)]);
    const onNeighborhoodBoxClick = (e: React.MouseEvent, offerId: number) => neighborhoodOffersClickHit(viewType, offerId);

    const listingHeadline = "Oferty, które mogą Cię zainteresować";

    return (
        <>
            <Text variant="headline_4" as="h3" css={headingStyle}>
                {listingHeadline}:
            </Text>

            {!isSuccess ? (
                <NearbyOffersPanelPlaceholder />
            ) : (
                <NearbyOffersPanel
                    offersNearby={nearbyOffers}
                    gtmData={{
                        listingName: listingHeadline,
                        country: getCountryId(country)
                    }}
                    onBoxClick={onNeighborhoodBoxClick}
                    modalQuery={{
                        isInitialized: !isUninitialized,
                        isSuccess,
                        isLoading: isLoading || isFetching,
                        isError,
                        requestState: getRequestStateFromRtkQuery({isSuccess, isLoading, isFetching, isError}),
                        data: nearbyOffers,
                        count: nearbyOffers.length,
                        page: nearbyOffersResponse.page,
                        pageSize: nearbyOffersResponse.page_size
                    }}
                />
            )}
        </>
    );
};

const headingStyle = (theme: Theme) => css`
    margin-bottom: 2.4rem;
    @media (min-width: ${theme.breakpoints.md}) {
        margin-bottom: 3.6rem;
    }
`;
